import { root } from '../../../store/constants';

export const COLOR_TAGS_COUNT = 1;

export const getColorTagsSessionRecordingNeeded = (
    colorTagsCount: number,
) => {
    if (!root.App.controller.mainView.getColorTagsSessionRecording()) {
        return false;
    }
    return colorTagsCount === COLOR_TAGS_COUNT;
};
